import * as React from 'react'
import { parseQueryString } from '../utils'
import { Spinner, Errors } from '../@components'
import { apiClient } from "../services/appClient"
import { IError } from '../services/errorService'

enum ActivatePatronPageStages {
    Init,
    Completed,
    Error
}

interface IActivatepatronPageState {
    stage: ActivatePatronPageStages,
    error?: IError;
    activation_token: string;
    request: boolean;
}

export class ActivatePatronPage extends React.Component<{}, IActivatepatronPageState> {
    constructor(props: {}) {
        super(props);

        var params = parseQueryString(location.search);
        this.state = {
            activation_token: params.activation_token,
            stage: ActivatePatronPageStages.Init,
            request: true
        }
    }

    public componentDidMount() {
        apiClient.activatePatron({ activationToken: this.state.activation_token })
            .then(data => {
                this.setState({
                    error: undefined,
                    stage: ActivatePatronPageStages.Completed,
                    request: false
                });
            })
            .catch(error => {
                this.setState({
                    stage: ActivatePatronPageStages.Error,
                    error: error,
                    request: false
                });
            });
    }

    public render() {
        return (
            <form className="form-horizontal">
                {this.renderInternal()}
            </form>
        );
    }

    private renderInternal() {
        switch (this.state.stage) {
            case ActivatePatronPageStages.Init:
                return this.renderInit();
            case ActivatePatronPageStages.Error:
                return this.renderError();
            default:
                return this.renderFinal();
        }
    }

    public renderError() {
        return (
            <React.Fragment>
                <div className="page-header">
                    <h1>Oops! Something went wrong</h1>
                </div>
                <Errors error={this.state.error} />
            </React.Fragment>);
    }

    public renderInit() {
        return (
            <React.Fragment>
                <div className="page-header">
                    <h1>Account Activation</h1>
                </div>
                <p>Account activation is in process</p>
                <div className="form-group">
                    <div className="col-sm-offset-3 col-sm-9">
                        <Spinner show={this.state.request} />
                    </div>
                </div>
            </React.Fragment>
        );
    }

    public renderFinal() {
        return (
            <React.Fragment>
                <div className="page-header">
                    <h1>Account Activation Successful</h1>
                </div>
                <p>
                    Your account has been successfully activated.
                </p>
                <p>
                    Please close this window and login to your SmarTrip(R) account.
                </p>
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/activate.tsx